var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39.701mm",
    height: "39.701mm",
    viewBox: "0 0 150.05 150.05",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -.00179)",
    d: "m27.932 1.5625c-0.96612 1e-7 -1.9335 0.36908-2.6738 1.1094l-22.586 22.586c-1.4806 1.4806-1.4806 3.8651 0 5.3457l44.422 44.422-44.422 44.422c-1.4806 1.4806-1.4806 3.8632 0 5.3438l22.586 22.586c1.4806 1.4806 3.8651 1.4806 5.3457 0l44.422-44.422 44.422 44.422c1.4806 1.4806 3.8632 1.4806 5.3438 0l22.586-22.586c1.4806-1.4806 1.4806-3.8632 0-5.3438l-44.422-44.422 44.422-44.422c1.4806-1.4806 1.4806-3.8651 0-5.3457l-22.586-22.586c-1.4806-1.4806-3.8632-1.4806-5.3438 0l-44.422 44.422-44.422-44.422c-0.74029-0.74029-1.7058-1.1094-2.6719-1.1094z",
    strokeLinecap: "round",
    strokeWidth: 0.59753
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.15d2f53a8006d5e0dd5a2d916d3de5af.svg";
export { ForwardRef as ReactComponent };